import { createContext, useContext } from "react";

export const CmsBaseContext = createContext("/portal");
export const useCmsBase = () => useContext(CmsBaseContext);
